import { render, staticRenderFns } from "./JobDetailsBottomBar.vue?vue&type=template&id=8af47dc0&scoped=true&"
import script from "./JobDetailsBottomBar.vue?vue&type=script&lang=ts&"
export * from "./JobDetailsBottomBar.vue?vue&type=script&lang=ts&"
import style0 from "./JobDetailsBottomBar.vue?vue&type=style&index=0&id=8af47dc0&lang=styl&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8af47dc0",
  null
  
)

export default component.exports